// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-level[data-v-2e825bd2] {\n  font-size: 11px;\n  border: 1px solid #707070;\n  border-radius: 10px;\n  width: 50px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
